/** Load the next server page for collection and search grids. */
if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('.load-more');
      this.grid = this.closest('responsive-collection-products')?.querySelector('#product-grid')
        || document.getElementById('product-grid');
      this.nextUrl = this.dataset.nextUrl;
      if (this.classList.contains('pagination-type--paginated')) return;
      if (this.classList.contains('pagination-type--loadmore')) {
        this.button?.addEventListener('click', () => this.loadProducts());
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.button?.addEventListener('click', () => this.loadProducts());
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadProducts();
        });
        this.observer.observe(this);
      }
      this.updateEndState();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    updateEndState() {
      if (!this.nextUrl) {
        this.observer?.disconnect();
        this.hidden = true;
        this.style.display = 'none';
      }
    }
    async loadProducts() {
      if (this.hasAttribute('loading') || !this.nextUrl || !this.grid) return;
      this.setAttribute('loading', 'true');
      if (this.button) this.button.disabled = true;
      this.controller = new AbortController();
      const url = this.nextUrl;
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(`Pagination request failed: ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        let root = doc;
        if (this.closest('responsive-collection-products') && window.matchMedia('(max-width: 768px)').matches) {
          root = doc.querySelector('template[data-mobile-products]')?.content || doc;
        }
        const grid = root.querySelector('#product-grid');
        if (!grid) throw new Error('Product grid missing from pagination response');
        if (!this.isConnected) return;
        const products = Array.from(grid.children);
        this.grid.append(...products);
        this.nextUrl = root.querySelector('pagination-theme')?.dataset.nextUrl || '';
        this.dataset.nextUrl = this.nextUrl;
        this.updateEndState();
        if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
          gsap.fromTo(products, { opacity: 0, y: 30 }, { duration: 0.5, y: 0, opacity: 1, stagger: 0.05 });
        }
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('pagination:page-changed', { url });
        }
        if (typeof window.jQuery === 'function') {
          window.jQuery(products).find('.product-v-img .product-card-swatch').on('mouseenter', function() {
            const swatch = window.jQuery(this);
            swatch.parents('.product-v-img').siblings('.product-v-name').text(swatch.attr('data-pname'));
          });
        }
        // Re-observe after layout so short pages can continue filling the viewport.
        if (this.observer && this.nextUrl) {
          this.observer.unobserve(this);
          requestAnimationFrame(() => { if (this.isConnected) this.observer.observe(this); });
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
          // Infinite scrolling also exposes a retry button after a network error.
          this.classList.remove('pagination-type--infinite');
          this.classList.add('pagination-type--loadmore');
          this.observer?.disconnect();
        }
      } finally {
        this.removeAttribute('loading');
        if (this.button) this.button.disabled = false;
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
